import LeftArrow from "@/assets/SVG/leftArrow";
import { Modal } from "@/components";
import { Grid, IconButton, Typography, useMediaQuery } from "@mui/material";

function AllTripsInfoCard({ img, title, desc }) {
  const md = useMediaQuery("(max-width:450px)");
  return (
    <Modal width={md ? "100%" : "33%"} sx={{ padding: "20px" }}>
      <Grid
        display={"flex"}
        flexDirection={"row"}
        alignContent={"center"}
        alignItems={"center"}
        justifyItems={"center"}
        justifyContent={"center"}
        margin={"20px"}
      >
        <img height={"130px"} src={img} />
      </Grid>
      <div
        style={{
          height: "1px",
          width: "100%",
          borderBottom: `1px solid var(--emr-darkblue)`,
        }}
      ></div>
      <Typography variant="body1" sx={{ marginTop: "10px" }}>
        {title}
      </Typography>
      <Typography
        mt={"5px"}
        variant="caption"
        color="var(--emr-primary-color-text)"
      >
        {desc}
      </Typography>
      <Grid
        mt={"20px"}
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        sx={{ cursor: "pointer" }}
      >
        <Typography color={"var(--emr-primary)"}>مشاهده</Typography>
        <IconButton>
          <LeftArrow />
        </IconButton>
      </Grid>
    </Modal>
  );
}

export default AllTripsInfoCard;
